import React from 'react';
import HeaderForm from './form';
import {getBannerHeader, updateBannerHeaderItem,updateProductItem} from '../../modules/Api';
import {normalizer, prepareForEdit} from '../Coupons/pipeline';
import {notification} from 'antd';
import history from '../../modules/History';

class EditBannerHeader extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
        
    }
    componentDidMount() {
        this.fetchCouponDetail();
    }
    fetchCouponDetail() {
        const ads_id = this.props.match.params.id;
        getBannerHeader(ads_id, data => {this.setState({data: prepareForEdit(data)})});
    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const ads_id = this.props.match.params.id;
        const formData = normalizer(values, this.state.data);
        updateBannerHeaderItem(ads_id, formData, () => {
            notification.open({
                message: `بنر با موفقیت ویرایش شد!`,
                description: ``
            });
            this.setState({submitted: false});
            history.item.push(`/banner`);
        })
    }
    render() {
        if(!this.state.data.id){
            return (<div>لطفا منتظر بمانید</div>);
        }
        return (<div><HeaderForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default EditBannerHeader;


// WEBPACK FOOTER //
// ./src/containers/Header/edit.js